import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";

export default class ContractingProgressClaim extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'contractingprogressclaim',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.refreshData();
	}
	save(e) {
		e.preventDefault();

		if (this.isBlank(this.state.data.record.claimNumber)) this.state.data.record.claimNumber = 0;

		this.httpPost("api/v1/contractingprogressclaim/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			claimDate: this.convertMomentToDb(this.state.data.record.claimDate),
			claimNumber: this.state.data.record.claimNumber,
			contractingContractId: this.state.data.record.contractingContractId,
			status: this.state.data.record.status,
			lines: this.state.data.record.lines,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("صورت وضعیت با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	refreshData() {
		this.httpPost("api/v1/contractingprogressclaim/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankLine() {
		return {
			id: this.uuidv4(),
			order: this.state.data.record.lines.length + 1,
			description: '',
			unitPrice: 0,
			quantity: 0,
			amount: 0,
		}
	}
	addNewLine() {
		this.state.data.record.lines.push(this.getBlankLine());
		this.setState({ data: this.state.data });
	}
	removeLine(id) {
		var temp = [];
		this.state.data.record.lines.forEach(t => {
			if (t.id !== id) temp.push(t);
		});

		this.state.data.record.lines = temp;
		this.setState({ data: this.state.data });
	}
	setLine(id, f, e) {
		this.state.data.record.lines.forEach(t => {
			if (t.id === id) {
				t[f] = e;
			}

			t.amount = parseInt(this.FixedPointNumber(t.quantity*t.unitPrice,0));
		});

		this.setState({ data: this.state.data });
	}
	setContract(e){
		this.state.data.record.contractingContractId = e.value;
		this.state.data.record.contractingContractTitle = e.label;

		this.setState({ data: this.state.data });
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">صورت وضعیت</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>

							<div className="row">
								<div className="col-sm-4">
									<div className="form-group">
										<label for="invoiceContact" className="title1">قرارداد<span className="red">*</span></label>
										<SelectAsync
											value={!this.isNull(this.state.data.record.contractingContractId) && this.state.data.record.contractingContractId != this.defaultGuid() ? [{ value: this.state.data.record.contractingContractId, label: this.state.data.record.contractingContractTitle }] : null}
											isMulti={false}
											placeholder="انتخاب قرارداد"
											defaultOptions
											loadOptions={(inputValue, callback) => this.loadContractingContractsOptions(inputValue, callback)}
											onChange={e => this.setContract(e)}
										/>
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
											<DatePicker
												inputReadOnly={false}
												className="form-control input-sm persian-date"
												placeholder={"تاریخ"}
												isGregorian={false}
												showTodayButton={true}
												timePicker={false}
												onChange={(e) => { this.state.data.record.claimDate = e }}
												value={this.getFormatedDateForDatePicker(this.state.data.record.claimDate)}
											/>
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">شماره<span className="red">*</span></label>
											<input onChange={e => this.state.data.record.claimNumber = parseInt(e.target.value)} defaultValue={this.state.data.record.claimNumber} autocomplete="off" type="text" className="form-control input-smnumber" maxLength="20" />
												
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">وضعیت</label>
										<select onChange={e => this.state.data.record.status = parseInt(e.target.value)} defaultValue={this.state.data.record.status} className="form-control input-smnumber">
										<option value="1">پیش نویس</option>
                                            <option value="2">ارسال شده</option>
                                            <option value="3">تایید شده</option>
                                            <option value="4">پرداخت شده</option>
										</select>
									</div>
								</div>
								
								</div>
								<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td>شرح اقدامات<span className="red">*</span></td>
												<td style={{ "width": "80px" }}>
													<span>تعداد/مقدار<span className="red">*</span></span>
												</td>
												<td style={{ "width": "100px" }}>مبلغ واحد <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
												<td style={{ "width": "100px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.record.lines.sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
													</td>
													<td>
														<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setLine(item.id, 'description', e.target.value)} />
													</td>
													<td>
														<NumberFormat value={item.quantity} onChange={e => this.setLine(item.id, 'quantity', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td><NumberFormat value={item.unitPrice} onChange={e => this.setLine(item.id, 'unitPrice', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
													<td>
														<NumberFormat readOnly={true} value={item.amount} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td>
														<span title="حذف سطر" onClick={e => this.removeLine(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
													</td>
												</tr>
											)}
										</tbody>
										<tfoot style={{ "backgroundColor": "whitesmoke" }}>
											<tr>
												<td colspan="6">													
											<a className="btn btn-primary" onClick={e => this.addNewLine()}>افزودن سطر جدید</a>
												</td>
											</tr>
										</tfoot>
									</table>

						</div>
						<div className="modal-footer">
						<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}